var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c("header", { staticClass: "header header--step" }, [
      _c("div", { staticClass: "header__container" }, [
        _c("div", { staticClass: "header__row" }, [
          _c("button", {
            staticClass: "prev",
            class: { "first-index-prev-off": this.swiperIndex == 1 },
            attrs: { type: "button", "aria-lebel": "이전" },
            on: {
              click: function($event) {
                return _vm.swiperSlidePrev()
              }
            }
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "close",
            attrs: { type: "button", "aria-label": "닫기" },
            on: {
              click: function($event) {
                return _vm.moveMainHome()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("nav", { staticClass: "step" }, [
          _c("ol", { staticClass: "step__row" }, [
            _c(
              "li",
              {
                staticClass: "step__step",
                attrs: { "aria-current": this.swiperIndex <= 8 ? "step" : null }
              },
              [
                _c("span", [_vm._v("1")]),
                _vm._v(" "),
                _c("p", [_vm._v("알쏭달쏭 단백질 퀴즈")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "step__step",
                attrs: {
                  "aria-current": this.swiperIndex === 9 ? "step" : null
                }
              },
              [
                _c("span", [_vm._v("2")]),
                _vm._v(" "),
                _c("p", [_vm._v("단백질 부족 자가진단")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "step__step",
                attrs: {
                  "aria-current":
                    this.swiperIndex === 10 || this.swiperIndex === 11
                      ? "step"
                      : null
                }
              },
              [
                _c("span", [_vm._v("3")]),
                _vm._v(" "),
                _c("p", [_vm._v("하루 권장 섭취량 체크")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "progress-bar" }, [
          _c("div", { staticClass: "progress-bar__row" }, [
            _c("div", { staticClass: "progress-bar__bar" }, [
              _c("div", { style: { width: _vm.stepOneProgressBarWidth } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-bar__bar" }, [
              _c("div", { style: { width: _vm.stepTwoProgressBarWidth } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-bar__bar" }, [
              _c("div", { style: { width: _vm.stepThrProgressBarWidth } })
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c("div", { staticClass: "protein-check" }, [
        _c("div", { staticClass: "protein-check__swiper" }, [
          _c("div", { staticClass: "swiper-container" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              [
                _c(
                  "swiper",
                  { ref: "mySwiper", attrs: { options: _vm.swiperOption } },
                  [
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "1" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q1")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      단백질은 운동하는 사람에게만"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      중요한 영양소이다?\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer--ox" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q1,
                                      expression: "myproteinQuiz.Q1"
                                    }
                                  ],
                                  attrs: {
                                    value: "O",
                                    type: "radio",
                                    id: "question01_01",
                                    name: "question01"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q1, "O")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q1",
                                          "O"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question01_01",
                                    "aria-label": "O"
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q1,
                                      expression: "myproteinQuiz.Q1"
                                    }
                                  ],
                                  attrs: {
                                    value: "X",
                                    type: "radio",
                                    id: "question01_02",
                                    name: "question01"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q1, "X")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q1",
                                          "X"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question01_02",
                                    "aria-label": "X"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "2" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q2")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v("\n                      단백질,"),
                              _c("br"),
                              _vm._v(
                                "\n                      한번에 많이 먹을수록 좋다?\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer--ox" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q2,
                                      expression: "myproteinQuiz.Q2"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    value: "O",
                                    id: "question02_01",
                                    name: "question02"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q2, "O")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q2",
                                          "O"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question02_01",
                                    "aria-label": "O"
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q2,
                                      expression: "myproteinQuiz.Q2"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    value: "X",
                                    id: "question02_02",
                                    name: "question02"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q2, "X")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q2",
                                          "X"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question02_02",
                                    "aria-label": "X"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "3" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q3")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      나이가 들수록 체내 단백질이"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      자연스럽게 줄어든다?\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer--ox" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q3,
                                      expression: "myproteinQuiz.Q3"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    value: "O",
                                    id: "question03_01",
                                    name: "question03"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q3, "O")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q3",
                                          "O"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question03_01",
                                    "aria-label": "O"
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q3,
                                      expression: "myproteinQuiz.Q3"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    value: "X",
                                    id: "question03_02",
                                    name: "question03"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q3, "X")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q3",
                                          "X"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question03_02",
                                    "aria-label": "X"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "4" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q4")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      운동만 열심히 하면"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      근육이 늘어난다?\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer--ox" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q4,
                                      expression: "myproteinQuiz.Q4"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    value: "O",
                                    id: "question04_01",
                                    name: "question04"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q4, "O")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q4",
                                          "O"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question04_01",
                                    "aria-label": "O"
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q4,
                                      expression: "myproteinQuiz.Q4"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    value: "X",
                                    id: "question04_02",
                                    name: "question04"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q4, "X")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q4",
                                          "X"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: {
                                    for: "question04_02",
                                    "aria-label": "X"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "5" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q5")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      다음 중 ‘좋은 단백질 제품을"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      고르는 기준’으로 맞는 내용을"
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "line-highlight" }, [
                                _vm._v("모두")
                              ]),
                              _vm._v(" 골라주세요.\n                      "),
                              _c("em", [_vm._v("(중복 선택)")])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "quiz__answer" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.myproteinQuiz.Q5,
                                    expression: "myproteinQuiz.Q5"
                                  }
                                ],
                                attrs: {
                                  value: "1",
                                  type: "checkbox",
                                  id: "question05_01"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.myproteinQuiz.Q5)
                                    ? _vm._i(_vm.myproteinQuiz.Q5, "1") > -1
                                    : _vm.myproteinQuiz.Q5
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.myproteinQuiz.Q5,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "1",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.myproteinQuiz, "Q5", $$c)
                                      }
                                    },
                                    function($event) {
                                      return _vm.nextQuestion()
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "question05_01" } }, [
                                _vm._v(
                                  "식약처 인증 건강기능식품 제품을 선택한다."
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.myproteinQuiz.Q5,
                                    expression: "myproteinQuiz.Q5"
                                  }
                                ],
                                attrs: {
                                  value: "2",
                                  type: "checkbox",
                                  id: "question05_02"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.myproteinQuiz.Q5)
                                    ? _vm._i(_vm.myproteinQuiz.Q5, "2") > -1
                                    : _vm.myproteinQuiz.Q5
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.myproteinQuiz.Q5,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "2",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.myproteinQuiz, "Q5", $$c)
                                      }
                                    },
                                    function($event) {
                                      return _vm.nextQuestion()
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "question05_02" } }, [
                                _vm._v(
                                  "품질 유지와 맛있는 맛을 위해 첨가물이 많은 제품을 선택한다."
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.myproteinQuiz.Q5,
                                    expression: "myproteinQuiz.Q5"
                                  }
                                ],
                                attrs: {
                                  value: "3",
                                  type: "checkbox",
                                  id: "question05_03"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.myproteinQuiz.Q5)
                                    ? _vm._i(_vm.myproteinQuiz.Q5, "3") > -1
                                    : _vm.myproteinQuiz.Q5
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.myproteinQuiz.Q5,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "3",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.myproteinQuiz, "Q5", $$c)
                                      }
                                    },
                                    function($event) {
                                      return _vm.nextQuestion()
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "question05_03" } }, [
                                _vm._v(
                                  "아미노산 스코어가 100 이상인 높은 영양가 제품을 선택한다."
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.myproteinQuiz.Q5,
                                    expression: "myproteinQuiz.Q5"
                                  }
                                ],
                                attrs: {
                                  value: "4",
                                  type: "checkbox",
                                  id: "question05_04"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.myproteinQuiz.Q5)
                                    ? _vm._i(_vm.myproteinQuiz.Q5, "4") > -1
                                    : _vm.myproteinQuiz.Q5
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.myproteinQuiz.Q5,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "4",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.myproteinQuiz,
                                              "Q5",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.myproteinQuiz, "Q5", $$c)
                                      }
                                    },
                                    function($event) {
                                      return _vm.nextQuestion()
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "question05_04" } }, [
                                _vm._v(
                                  "철저한 원재료 구분 유통 관리로 검증 된 원재료를 사용한 제품을 선택한다."
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "6" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q6")])
                            ]),
                            _vm._v(" "),
                            _c("em", { staticClass: "quiz__noti" }, [
                              _vm._v("빈칸에 들어갈 숫자는 무엇일까요?")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      우리 몸에 반드시 필요한"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      필수 및 비필수 아미노산은"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      총 ____ 종이다.\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q6,
                                      expression: "myproteinQuiz.Q6"
                                    }
                                  ],
                                  attrs: {
                                    value: "1",
                                    type: "radio",
                                    id: "question06_01",
                                    name: "question06"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q6, "1")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q6",
                                          "1"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question06_01" } },
                                  [_vm._v("5종")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q6,
                                      expression: "myproteinQuiz.Q6"
                                    }
                                  ],
                                  attrs: {
                                    value: "2",
                                    type: "radio",
                                    id: "question06_02",
                                    name: "question06"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q6, "2")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q6",
                                          "2"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question06_02" } },
                                  [_vm._v("10종")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q6,
                                      expression: "myproteinQuiz.Q6"
                                    }
                                  ],
                                  attrs: {
                                    value: "3",
                                    type: "radio",
                                    id: "question06_03",
                                    name: "question06"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q6, "3")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q6",
                                          "3"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question06_03" } },
                                  [_vm._v("20종")]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "7" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q7")])
                            ]),
                            _vm._v(" "),
                            _c("em", { staticClass: "quiz__noti" }, [
                              _vm._v("빈칸에 들어갈 숫자는 무엇일까요?")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      단백질 섭취 골든타임은"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      운동 직후 ____ 이내이다.\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q7,
                                      expression: "myproteinQuiz.Q7"
                                    }
                                  ],
                                  attrs: {
                                    value: "1",
                                    type: "radio",
                                    id: "question07_01",
                                    name: "question07"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q7, "1")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q7",
                                          "1"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question07_01" } },
                                  [_vm._v("10분")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q7,
                                      expression: "myproteinQuiz.Q7"
                                    }
                                  ],
                                  attrs: {
                                    value: "2",
                                    type: "radio",
                                    id: "question07_02",
                                    name: "question07"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q7, "2")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q7",
                                          "2"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question07_02" } },
                                  [_vm._v("45분")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q7,
                                      expression: "myproteinQuiz.Q7"
                                    }
                                  ],
                                  attrs: {
                                    value: "3",
                                    type: "radio",
                                    id: "question07_03",
                                    name: "question07"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q7, "3")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q7",
                                          "3"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question07_03" } },
                                  [_vm._v("2시간")]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "8" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q8")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      다음 중 단백질의 공식 기능이"
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "line-highlight" }, [
                                _vm._v("아닌 것")
                              ]),
                              _vm._v("은 무엇일까요?\n                    ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q8,
                                      expression: "myproteinQuiz.Q8"
                                    }
                                  ],
                                  attrs: {
                                    value: "1",
                                    type: "radio",
                                    id: "question08_01",
                                    name: "question08"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q8, "1")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q8",
                                          "1"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question08_01" } },
                                  [
                                    _vm._v(
                                      "근육, 결합조직 등 신체 조직의 구성 성분"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q8,
                                      expression: "myproteinQuiz.Q8"
                                    }
                                  ],
                                  attrs: {
                                    value: "2",
                                    type: "radio",
                                    id: "question08_02",
                                    name: "question08"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q8, "2")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q8",
                                          "2"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question08_02" } },
                                  [_vm._v("효소, 호르몬, 항체의 구성에 필요")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q8,
                                      expression: "myproteinQuiz.Q8"
                                    }
                                  ],
                                  attrs: {
                                    value: "3",
                                    type: "radio",
                                    id: "question08_03",
                                    name: "question08"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q8, "3")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q8",
                                          "3"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question08_03" } },
                                  [
                                    _vm._v(
                                      "체내 필수 영양성분이나 활성물질의 운반과 저장에 필요"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q8,
                                      expression: "myproteinQuiz.Q8"
                                    }
                                  ],
                                  attrs: {
                                    value: "4",
                                    type: "radio",
                                    id: "question08_04",
                                    name: "question08"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q8, "4")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q8",
                                          "4"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question08_04" } },
                                  [_vm._v("숙면에 도움")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q8,
                                      expression: "myproteinQuiz.Q8"
                                    }
                                  ],
                                  attrs: {
                                    value: "5",
                                    type: "radio",
                                    id: "question08_05",
                                    name: "question08"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q8, "5")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q8",
                                          "5"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question08_05" } },
                                  [_vm._v("체액, 산-염기의 균형 유지에 필요")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinQuiz.Q8,
                                      expression: "myproteinQuiz.Q8"
                                    }
                                  ],
                                  attrs: {
                                    value: "6",
                                    type: "radio",
                                    id: "question08_06",
                                    name: "question08"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.myproteinQuiz.Q8, "6")
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinQuiz,
                                          "Q8",
                                          "6"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question08_06" } },
                                  [_vm._v("에너지, 포도당, 지질의 합성에 필요")]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "1" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c(
                              "p",
                              {
                                staticClass: "quiz__noti quiz__noti--secondary"
                              },
                              [
                                _c("span", [_vm._v("혹시나도?")]),
                                _vm._v(" "),
                                _c("span", { staticClass: "line-highlight" }, [
                                  _vm._v("스스로 알아보는 단백질 부족신호")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      해당되는 항목이 있는지 체크해보세요.\n                      "
                              ),
                              _c("em", [_vm._v("(중복 선택)")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-1",
                                    type: "checkbox",
                                    id: "question09_01"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-1"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-1",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_01" } },
                                  [
                                    _vm._v(
                                      "머리카락이 많이 빠져 탈모가 걱정 된다."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-2",
                                    type: "checkbox",
                                    id: "question09_02"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-2"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-2",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_02" } },
                                  [
                                    _vm._v(
                                      "머리카락이 가늘어지거나 갈라지며 푸석푸석하다."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-3",
                                    type: "checkbox",
                                    id: "question09_03"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-3"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-3",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_03" } },
                                  [
                                    _vm._v(
                                      "피부가 거칠어지고 탄력을 잃고 주름이 생기는 것 같다."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-4",
                                    type: "checkbox",
                                    id: "question09_04"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-4"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-4",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_04" } },
                                  [
                                    _vm._v(
                                      "손톱 발톱이 얇아지고 쉽게 갈라지거나 부러진다."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-5",
                                    type: "checkbox",
                                    id: "question09_05"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-5"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-5",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_05" } },
                                  [
                                    _vm._v(
                                      "운동을 해도 근육이 잘 생기지 않고 전체적으로 근육량이 줄어든 느낌이 든다."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-6",
                                    type: "checkbox",
                                    id: "question09_06"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-6"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-6",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_06" } },
                                  [
                                    _vm._v(
                                      "면역력이 약해져 감기에 자주 걸리고 잘 낫지 않는다."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-7",
                                    type: "checkbox",
                                    id: "question09_07"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-7"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-7",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_07" } },
                                  [
                                    _vm._v(
                                      "혈액순환이 잘 되지 않아 손발이 차고 종아리나 발이 자주 붓는다."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-8",
                                    type: "checkbox",
                                    id: "question09_08"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-8"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-8",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_08" } },
                                  [_vm._v("단 음식이 자주 먹고싶다.")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-9",
                                    type: "checkbox",
                                    id: "question09_09"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-9"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-9",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_09" } },
                                  [_vm._v("항상 피곤하고 잔병치레가 많다.")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinSelfCheck.Q9,
                                      expression: "myproteinSelfCheck.Q9"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q9-10",
                                    type: "checkbox",
                                    id: "question09_10"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.myproteinSelfCheck.Q9
                                    )
                                      ? _vm._i(
                                          _vm.myproteinSelfCheck.Q9,
                                          "Q9-10"
                                        ) > -1
                                      : _vm.myproteinSelfCheck.Q9
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.myproteinSelfCheck.Q9,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Q9-10",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.myproteinSelfCheck,
                                                "Q9",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.myproteinSelfCheck,
                                            "Q9",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.nextQuestion()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question09_10" } },
                                  [
                                    _vm._v(
                                      "예전과 달리 무거운 것을 들기 힘들고 근력이 떨어진 것 같다."
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__etc" }, [
                              _vm._v(
                                "*출처 : Indian J Nutr Dietetics 57.4 (2020): 486-497., J. Food Sci. Nutr 1\n                      (2017): 645-647., Paediatrics and international child health 35.2 (2015): 83-89., Obesity\n                      reviews 6.2 (2005): 133-142. Seshadri, Divya, and Dipankar De. “Nails in nutritional\n                      deficiencies.” Indian Journal of Dermatology, Venereology and Leprology 78 (2012): 237."
                              )
                            ])
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "1" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q1")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v(
                                "\n                      단백질을 섭취하는 목적을"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                      알려주세요.\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "quiz__answer quiz__answer" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinPurpose.Q10,
                                      expression: "myproteinPurpose.Q10"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q10-1",
                                    type: "radio",
                                    id: "question10_01",
                                    name: "question10"
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.myproteinPurpose.Q10,
                                      "Q10-1"
                                    )
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinPurpose,
                                          "Q10",
                                          "Q10-1"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question10_01" } },
                                  [
                                    _vm._v(
                                      "\n                        건강을 위해 필수 영양소인"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                        단백질을 섭취하려고 해요.\n                      "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinPurpose.Q10,
                                      expression: "myproteinPurpose.Q10"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q10-2",
                                    type: "radio",
                                    id: "question10_02",
                                    name: "question10"
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.myproteinPurpose.Q10,
                                      "Q10-2"
                                    )
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinPurpose,
                                          "Q10",
                                          "Q10-2"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question10_02" } },
                                  [
                                    _vm._v(
                                      "\n                        탄탄한 몸을 위해"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                        체지방 조절을 하고 싶어요.\n                      "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.myproteinPurpose.Q10,
                                      expression: "myproteinPurpose.Q10"
                                    }
                                  ],
                                  attrs: {
                                    value: "Q10-3",
                                    type: "radio",
                                    id: "question10_03",
                                    name: "question10"
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.myproteinPurpose.Q10,
                                      "Q10-3"
                                    )
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.myproteinPurpose,
                                          "Q10",
                                          "Q10-3"
                                        )
                                      },
                                      function($event) {
                                        return _vm.moveSwiperSlide()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "question10_03" } },
                                  [_vm._v("근육 증가를 원해요.")]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("swiper-slide", [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          attrs: { "data-index-number": "2" }
                        },
                        [
                          _c("div", { staticClass: "quiz" }, [
                            _c("span", { staticClass: "quiz__chapter" }, [
                              _c("span", [_vm._v("Q2")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "quiz__question" }, [
                              _vm._v("몸무게를 알려주세요.")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "quiz__answer" }, [
                              _c("div", { staticClass: "quiz__form" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "a11y",
                                    attrs: { for: "weight" }
                                  },
                                  [_vm._v("몸무게 ")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.weight,
                                      expression: "weight"
                                    }
                                  ],
                                  attrs: {
                                    type: "number",
                                    id: "weight",
                                    maxlength: "5",
                                    placeholder: "00"
                                  },
                                  domProps: { value: _vm.weight },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.weight = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("kg")])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "quiz__etc" }, [
                                _vm._v(
                                  "*단백질 하루 권장 섭취량 계산에 필요합니다."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "button" }, [
                              _c("div", { staticClass: "button__row" }, [
                                _c("input", {
                                  staticClass:
                                    "button__item button__item--secondary",
                                  attrs: {
                                    id: "resultButton",
                                    type: "submit",
                                    value: "결과보기",
                                    disabled: this.weight <= 0
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.myproteinResult()
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "protein-check__next button",
            style: { display: this.nextSwiperButton ? "flex" : "none" }
          },
          [
            _c("div", { staticClass: "button__row" }, [
              _c(
                "button",
                {
                  staticClass: "button__item",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.nextButtonClose()
                    }
                  }
                },
                [_vm._v("\n            다음\n            "), _c("i")]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b450742", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b450742","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/myproteinQuiz.vue
// module id = null
// module chunks = 